import api           from '../../../../configs/api'
import Form          from '../../../../display/forms/FormElements'
import Event         from '../../../../things/Event'
import PropertyValue from '../../../../things/PropertyValue'
import Thing         from '../../../../things/Thing'

const superEvent =
{
    add :
    {
        agree       : 'Ajouter' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez sélectionner un événement parent en cliquant ci-dessous.' ,
        elements    :
        [
            {
                type       : Form.SEARCH_SELECTOR ,
                path       : api.events.url ,
                clazz      : Event,
                clearLabel : 'Vider' ,
                closeLabel : 'Fermer' ,
                init       :
                {
                    id        : 'value',
                    key       : 'value',
                    label     : 'Événement',
                    autoFocus : false,
                    fullWidth : true,
                    margin    : 'normal',
                    required  : true,
                    type      : 'search'
                },
                inputProps :
                {
                    label : 'Événement...'
                },
                logics :
                {
                    disabledSuggestions : ( props ) =>
                    {
                        const { rel } = props ;
                        let suggestions = [] ;
                        if( rel instanceof Thing )
                        {
                            const { subjectOf } = rel ;
                            if( subjectOf instanceof Thing )
                            {
                                if( subjectOf instanceof Event )
                                {
                                    suggestions.push( subjectOf ) ;
                                }
                                const { superEvent } = subjectOf ;
                                if( superEvent instanceof Array )
                                {
                                    suggestions.push( ...superEvent ) ;
                                }
                            }
                        }
                        return suggestions ;
                    }
                }
            }
        ],
        fail    : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading : 'Chargement en  cours...' ,
        prepare : ( item ) =>
        {
            return (
            {
                value : item.value
            });
        },
        mapUri : ( item , uri ) =>
        {
            if( item instanceof PropertyValue)
            {
                const { value } = item ;
                if( value instanceof Thing )
                {
                    return uri + '/' + value.id ;
                }
            }
            return uri ;
        },
        success : 'Ajout du nouvel événement réussi!' ,
        title   : 'Ajouter un événement'
    },
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer cet événement parent:' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer l\'événement ?'
    },
    title : 'Événements parents' ,
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Éditer" ,
        remove : "Supprimer"
    }
};

export default superEvent ;
